import { Box, Stack, Typography } from '@mui/material';
import ButtonWithLoading from 'src/components/common/ButtonWithLoading';
import RouterLinkNoUnderline from 'src/components/common/RouterLinkNoUnderline';
import ModalComponent from 'src/components/Modal/ModalComponent';
import { AFFILIATE_CODE_WIDGET } from 'src/utils/constants/config';
import { NoAuthRouteKeys } from 'src/utils/constants/routes';
import { getOriginUrl } from 'src/utils/helpers/stringHelpers';

const PopupRedirect = ({
  open,
  handleClose,
  title,
  imageBanner,
  imageLogo,
}: {
  open: boolean;
  handleClose: () => void;
  title: string;
  imageBanner: React.ReactNode;
  imageLogo: React.ReactNode;
}) => {
  const affiliateCodeWidget = localStorage.getItem(AFFILIATE_CODE_WIDGET);
  return (
    <ModalComponent
      styleBox={{ width: 540 }}
      open={open}
      handleClose={handleClose}
      // showCloseIcon={true}
      closeOnBackdropClick={false}
    >
      <Stack spacing={2}>
        {imageLogo}
        {imageBanner}
        <Typography textAlign={'center'} variant="h6">
          {title}
        </Typography>
        <Typography variant="body1" align="center">
          For full trade intelligence — including buyers, suppliers, shipment data and market analysis — access the
          ADAMftd platform. You can begin with <b>Starter Access</b>, our introductory access level for exploring the
          platform.
        </Typography>
        <Stack direction="row" spacing={3} mt={3} justifyContent="center" alignItems="center">
          <RouterLinkNoUnderline
            to={`${getOriginUrl()}${NoAuthRouteKeys.SignUp}?ref=${affiliateCodeWidget}`}
            target="_blank"
          >
            <ButtonWithLoading variant="contained" size="large">
              Explore ADAMftd Platform
            </ButtonWithLoading>
          </RouterLinkNoUnderline>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default PopupRedirect;
